const items = [
  {
    icon: 'ri-crosshair-2-line',
    title: '网站定位',
    desc: '作为漫画迷的追更收藏站，我们专注于连载更新提醒、收藏管理与追漫日历，不掺杂无关功能，把追更体验做到极致。',
    tone: 'bg-primary-100 text-primary-700',
  },
  {
    icon: 'ri-lightbulb-line',
    title: '发展理念',
    desc: '以用户需求驱动产品迭代。我们相信好的工具是「用出来的」，每一项功能都来自真实追更用户的反馈与打磨。',
    tone: 'bg-accent-100 text-accent-700',
  },
  {
    icon: 'ri-seedling-line',
    title: '长期陪伴',
    desc: '我们愿意陪每一部连载走完它的旅程。无论作品连载三年还是十年，你的追更清单和阅读进度都会稳稳保存。',
    tone: 'bg-secondary-100 text-secondary-800',
  },
];

export default function Mission() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold tracking-wide text-accent-700">定位与理念</span>
          <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">我们为什么而做</h2>
          <p className="mt-4 text-foreground-600">清晰的产品定位，加上朴素的长期主义，构成了我爱漫画网的一切。</p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
          {items.map((item) => (
            <div
              key={item.title}
              className="rounded-2xl border border-background-200/70 bg-background-50 p-6"
            >
              <span className={`flex h-12 w-12 items-center justify-center rounded-xl ${item.tone}`}>
                <i className={`${item.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-5 text-lg font-bold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}